import { Action, createReducer, on } from '@ngrx/store';
import { AgingPeriodViewCacheActions } from '../actions';
import { initialState, AgingPeriodViewCacheState } from '../states/view-cache.states';

export const agingPeriodViewCacheFeatureKey = 'agingPeriodViewCache';

export const viewCacheReducer = createReducer(
  initialState,
  on(AgingPeriodViewCacheActions.cacheAgingPeriod, (state, action) => ({...state, agingPeriod: action.cache}))
);

export function agingCacheReducer(state: AgingPeriodViewCacheState | undefined, action: Action) {
  return viewCacheReducer(state, action);
}


